import { splitSeconds } from './countdown'
import { expiresInDays, specialTimerKind } from './special-challenge-model'
import { m } from '~/paraglide/messages'

// The one countdown-label rule the entry card and the detail view share, so
// the two surfaces can never disagree.
export function specialTimerText(
  kind: 'upcoming' | 'active' | 'grace',
  totalSeconds: number,
): string {
  const timer = specialTimerKind(kind)
  if (timer === 'start') {
    const parts = splitSeconds(totalSeconds)
    return m.special_event_timer_count_down({
      day: parts.day,
      hour: parts.hour,
    })
  }
  if (timer === 'expires') {
    return m.special_event_timer_reward_count_down({
      day: expiresInDays(totalSeconds),
    })
  }
  return m.monthly_challenge_timer(splitSeconds(totalSeconds))
}
